import { motion } from "framer-motion";
import { useAbVariant } from "@/hooks/useAbVariant";

const ease = [0.16, 1, 0.3, 1];

const ITEMS = [
  {
    n: "01",
    title: "Bespoke Studio Consultation",
    body: "An unhurried meeting to understand you, your style, and your day.",
  },
  {
    n: "02",
    title: "Private Engagement Shoot",
    body: "Step in front of the lens. Rehearse posing. Find your angles.",
  },
  {
    n: "03",
    title: "A Framed Print, On Us",
    body: "Walk away with your favourite frame. A first heirloom for the wall.",
  },
  {
    n: "04",
    title: "Champagne & Conversation",
    body: "Sit down with a glass. No pressure, no script, just your vision.",
  },
];

export default function ValueStack() {
  const { copy, variant } = useAbVariant();
  return (
    <section
      id="value"
      data-testid="value-section"
      className="relative px-6 md:px-12 lg:px-24 py-20 md:py-28 bg-secondary"
    >
      <div className="grid grid-cols-1 gap-12 md:grid-cols-12 md:gap-10">
        <div className="lg:col-span-4">
          <p className="eyebrow text-muted-foreground mb-6 hidden">The Invitation</p>
          <h2 className="font-serif-display tracking-tight leading-[0.98] text-3xl sm:text-4xl md:text-5xl">
            What&apos;s included
            <br /> in your{" "}
            <span className="italic">£500</span>
            <br /> gift.
          </h2>
          <div className="hairline my-10 max-w-[280px] hidden" />
          <p className="text-foreground/75 leading-relaxed max-w-md">
            Currently free for the next 24 hours.
          </p>
          <a
            href="#apply"
            data-testid="value-cta"
            data-cta-variant={variant}
            className="mt-10 inline-flex items-center gap-3 eyebrow border-b border-foreground pb-1 hover:opacity-70 transition"
          >
            {copy.full} →
          </a>
        </div>

        <div className="lg:col-span-8 lg:pl-10">
          <ul>
            {ITEMS.map((it, idx) => (
              <motion.li
                key={it.n}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-80px" }}
                transition={{ duration: 0.8, ease, delay: idx * 0.08 }}
                data-testid={`value-item-${it.n}`}
                className="md:grid md:grid-cols-12 md:gap-6 items-start py-6 md:py-8 border-t border-border last:border-b"
              >
                <div className="md:col-span-1 font-serif-display italic text-lg md:text-3xl text-foreground/55 mb-2 md:mb-0">
                  {it.n}
                </div>
                <div className="md:col-span-5 mb-3 md:mb-0">
                  <h3 className="font-serif-display text-2xl md:text-3xl tracking-tight leading-tight break-words">
                    {it.title}
                  </h3>
                </div>
                <div className="md:col-span-6 text-foreground/75 leading-relaxed text-sm md:text-base break-words">
                  {it.body}
                </div>
              </motion.li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}
